import { Header, Footer, PageHero, AreasBlock, LocationBlock, EstimateForm } from "@/components/site";

export default function AreasPage() {
  return (
    <div className="bg-white text-slate-800">
      <Header />
      <PageHero overline="Where We Work" title="Service Areas" subtitle="Professional painting across Aurora, Newmarket, Richmond Hill, Vaughan, King City, Markham and the surrounding GTA." />
      <AreasBlock />
      <LocationBlock />
      <EstimateForm />
      <Footer />
    </div>
  );
}
